import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { removeTerm } from '@App/store/actions/search';

class SearchTerm extends Component {
    static propTypes = {
        term: PropTypes.string.isRequired,
        remove: PropTypes.func.isRequired,
    };

    render() {
        const { term, remove } = this.props;

        return (
            <div className="search-items--item search-term">
                {`"${term}"`}
                <button className="search-items--remove" type="button" onClick={remove}>
                    <i className="icon icon--clear"></i>
                </button>
            </div>
        );
    }
}

export default connect(
    null,
    (dispatch, props) => ({
        remove: () => dispatch(removeTerm(props.term)),
    })
)(SearchTerm);
